import React from "react";
import LogoImage from "./image/Logo.svg";
import { APP_VERSION } from "../../constants";

const ESLogo = () => {
  return (
    <div className="es-logo">
      <img src={LogoImage} alt="EtherStack Logo" />
      <div className="version-info"> {APP_VERSION} </div>
    </div>
  );
};

export default ESLogo;
